import { TeamDefault } from './TeamDefault';
import { LogoLayoutNavbar } from './../Home/components/LogoLayoutNavbar';

TeamDefault.Navbar = LogoLayoutNavbar;

export default TeamDefault;
